import { gql } from '@apollo/client';

const queryGetInvoiceDetails = gql`
  query invoiceDetailQuery($pk: Int!) @api(name: root) {
    invoice(pk: $pk) {
      id
      reference
      title
      contactEmail
      createdAt
      dueDate
      pdfUrl
      paidDate
      subject
      messageToBeneficiary
      bank {
        id
        name
        address
        accountId
        swiftCode
        currency
        iban
      }
      total
      currency
      customer {
        title
        address1
      }
      supplier {
        title
        address1
        vatNumber
      }
      lines {
        id
        description
        unitPrice
        quantity
        unitType
        total
        service {
          title
        }
      }
      payments {
        id
        createdAt
        amount
      }
    }
  }
`;

export default queryGetInvoiceDetails;
